import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { GoogleSearchScreenshotsState } from './state';

export const getters = {
    googleSearchFinished: (state: GoogleSearchScreenshotsState) => state.finished,
    googleSearchState: (state: GoogleSearchScreenshotsState) => state.state,
    googleSearchVerificationHistory: (state: GoogleSearchScreenshotsState) =>
      state.verificationHistory,
    googleSearchVerificationHistoryTotal: (
      state: GoogleSearchScreenshotsState,
    ) => state.verificationHistoryTotal,
};

const { read } = getStoreAccessors<GoogleSearchScreenshotsState, State>('');

export const readGoogleSearchFinished = read(getters.googleSearchFinished);
export const readGoogleSearchState = read(getters.googleSearchState);
export const readGoogleSearchVerificationHistory = read(
  getters.googleSearchVerificationHistory,
);
export const readGoogleSearchVerificationHistoryTotal = read(
  getters.googleSearchVerificationHistoryTotal,
);
